/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestQuranApps from "views/articles/BestQuranApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenTR = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestQuranApps["tr"]
  return (
    <InstantArticle {...article}>
      <div dir="ltr" style={{ textAlign: "justify" }}>
        <AppsListItem {...apps.find((item) => item.trackId === 706037876)} />
        <AppsListItem {...apps.find((item) => item.trackId === 385990290)} />
        <AppsListItem {...apps.find((item) => item.trackId === 328962407)} />
        <br />
        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Kullandığınız herhangi bir favori uygulamanız var mı? Favori
              uygulamalarınızı Appollow&apos;un{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  paylaşım sayfası
                </span>
              </Link>{" "}
              aracılığıyla gönderebilirsiniz.
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenTR
